export enum PaymentMethod {
  creditCard = 'Cartão de crédito',
  debitCard = 'Cartão de débito',
  cash = 'Dinheiro',
  pix = 'Pix',
  bankSlip = 'Boleto',
}

export enum AppointmentPaymentMethod {
  CREDIT_CARD = 'credit_card',
  PIX = 'pix',
}
